export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_HELP';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_HELP';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_HELP';
export const DEFAULT = 'DEFAULT_HELP';
export const OPEN_MODAL_WITH_CONTENT = "OPEN_MODAL_WITH_CONTENT_HELP";
export const CLOSE_MODAL = "CLOSE_MODAL_HELP";

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
